import React, { useState } from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import { UiButtonPrimary } from "../../components/form/UiButton"
import {
    UiContentWr,
    UiTopInputWr,
    UiTopInputHeading,
    UiContentCol,
    UiContentColWithSlider,
    UiColTitleWr,
    UiColTitle,
    UiViewAll,
    UiTabContentWr,
    UiTabContent,
    UiContentWheelCol
} from "../../components/common/UiPageElements"
import UiMainWrapper from "../../components/common/UiMainWrapper"
import TopHeader from "../../components/header/TopHeader"
import Footer from "../../components/footer/Footer"
import CurrentCampaigns from "./views/CuurentCampaigns"
import TrendingAcrossSherbet from "./views/TrendingAcrossSherbet"
import { UiScrollNavWr, UiScrollNavItem } from "../../components/common/UiScrollToElements"
import UiHowSherbetWork from "../../components/common/UiHowSherbetWork"
import { UiSalesChainElement, UiSalesChainElementWr, UiSalesChainElementNoBgWr } from "../../components/common/UiSalesChainElements"
import IncentiveHomeBgSlider from "./views/IncentiveHomeBgSlider"
import UiHowCampaignsWork from ".././../components/common/UiHowCampaignsWork"
import UiFeaturedCampaignSection from "../../components/common/UiFeaturedCampaignSection"
import UiIncentiveHistoryCard from "../../components/common/UiIncentiveHistoryCard"
import FeaturedBanner from"../../../../styles/img/volvo-car-banner.jpg"
import Wheel  from "../Spinwheel/Wheel"


export default function IncentivesHome(props) {

    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveHomeBgSlider />

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiHowCampaignsWork title="How Campaigns Work" />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="12" xl="8" className="sb-featured-campaign-border-wr">
                            <UiFeaturedCampaignSection 
                            featuredTitle="Volvo S90 Campaign"
                            backgroundImage={FeaturedBanner} >
                                 <p>Tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
                                        Ut enim ad minima veniam, quis nostrum.Tempora incidunt
                                        ut labore et dolore magnam aliquam quaerat voluptatem.
                                        <br /> <br />
                                        Ut enim ad minima veniam, quis nostrum.Ut enim ad minima veniam,
                                        quis nostrum.Tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.
                                        Ut enim ad minima veniam, quis nostrum.Ut enim ad minima veniam, quis nostrum.
                                        <br /><br />
                                        Ut enim ad minima veniam, quis nostrum.Ut enim ad minima veniam,
                                        quis nostrum.Tempora incidunt.
                                    </p>
                            </UiFeaturedCampaignSection>
                        </UiCol>
                        <UiCol lg="12" xl="4">
                            <UiContentCol>
                                <UiIncentiveHistoryCard heading="Incentive History" amount="5" qtyTitle="Last Active Campaigns">
                                    <UiSalesChainElementNoBgWr>
                                        <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                        <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />

                                    </UiSalesChainElementNoBgWr>
                                </UiIncentiveHistoryCard>
                            </UiContentCol>
                        </UiCol>
                        
                    </UiRowContainer>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <UiColTitleWr >
                                    <UiColTitle
                                        title="Latest Campaigns"
                                        subtitle="Current Campaigns"
                                        amount="10,442"
                                        />
                                </UiColTitleWr>
                                <UiSingleRow >
                                    <UiCol lg="11" >
                                        <UiSingleRow className="row-cols-1 row-cols-lg-2 row-cols-xl-5">
                                            <CurrentCampaigns />
                                        </UiSingleRow>
                                    </UiCol>
                                </UiSingleRow>
                            </UiContentCol>

                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <UiContentWr>
                    <UiRowContainer fluid="fluid" >
                        <UiCol lg="12" xl="12">
                            <UiContentCol>
                                <UiColTitleWr >
                                    <UiColTitle
                                        title="Trending vouchers"
                                        subtitle="Trending Rewards"
                                        amount="10,442"
                                        />
                                    <UiViewAll className="sb-current-campaign-view-all" />
                                </UiColTitleWr>
                                <UiSingleRow >
                                    <UiCol lg="11" >
                                        <UiSingleRow className="row-cols-1 row-cols-lg-2 row-cols-xl-5">
                                            <TrendingAcrossSherbet />
                                        </UiSingleRow>
                                    </UiCol>
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>
                <Footer />

            </UiMainWrapper>
        </>
    )
}



